'use client';

import NotFoundComponent from '@/components/error/404';

export default function NotFound() {
    return <NotFoundComponent />;
}
